import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/cs';

import { SINGLE_OFFICE_MODE } from '../../config';
import ConfirmForm from './ConfirmForm';
import TitleTop from '../../common/TitleTop/TitleTop';
import TextWrapper from '../../common/TextWrapper/TextWrapper';
import RowHorizontal from '../../common/RowHorizontal/RowHorizontal';
import InfoPanel from '../../common/InfoPanel/InfoPanel';
//import Timer from '../../common/Timer/Timer';

import { parseDateTimeToSpecificTimezone } from '../../common/Timezones';

class ConfirmInfo extends Component {
  render() {
    const {
      reservationCommon,
      previousSteps,
      confirmData,
      reserveData,
      inputs,
      error,
      handleChangeInput,
      handleOnClickConfirm,
      timezone,
      officeData,
      //handleTimerExpiration,
    } = this.props;

    /*let expiration = new Date(reserveData.data.expiration_start);
    expiration.setMinutes(expiration.getUTCMinutes() + reserveData.data.expiration_in_minutes);*/

    const time = parseDateTimeToSpecificTimezone(reserveData.data.time, reserveData.data.timezone);

    return (
      <div>
        <InfoPanel
          locationData={{
            show: true,
            title: previousSteps.one,
            text1: reserveData.data.store_name,
            text2: reserveData.data.store_address,
            place: officeData.place,
            placeAdditionalInfo: officeData.place_additional_info,
            isLoading: reserveData.isLoading,
            status: reserveData.status,
          }}
          serviceData={{
            show: true,
            title: previousSteps.two,
            text1: reserveData.data.service_name,
            isLoading: reserveData.isLoading,
            status: reserveData.status,
          }}
          timeData={{
            show: true,
            title: previousSteps.three,
            text1: moment(time).format('D.MM.YYYY'),
            text2: moment(time).format('H:mm'),
            isLoading: reserveData.isLoading,
            status: reserveData.status,
          }}
        />
      {/*
        <LabelStandart
          title="Časový limit pro rezervaci"
        />

        <Timer
          expirationDate={expiration}
          handleTimerExpiration={handleTimerExpiration}
        />
      */}
        <RowHorizontal />

        <TitleTop
          number={SINGLE_OFFICE_MODE ? 3 : 4}
          title={reservationCommon.title}
        />

        <TextWrapper>
          {<div dangerouslySetInnerHTML={{ __html: reservationCommon.content }}></div>}
        </TextWrapper>

        <ConfirmForm
          confirmData={confirmData}
          inputs={inputs}
          error={error}
          handleChangeInput={handleChangeInput}
          handleOnClickConfirm={handleOnClickConfirm}
          reservationCommon={reservationCommon}
        />
      </div>
    );
  }
}


ConfirmInfo.propTypes = {
  previousSteps: PropTypes.object.isRequired,
  reservationCommon: PropTypes.object.isRequired,
  inputs: PropTypes.object.isRequired,
  confirmData: PropTypes.object.isRequired,
  reserveData: PropTypes.object.isRequired,
  handleOnClickConfirm: PropTypes.func.isRequired,
  handleChangeInput: PropTypes.func.isRequired,
  //handleTimerExpiration: PropTypes.func.isRequired,
};

export default ConfirmInfo;



// WEBPACK FOOTER //
// ./src/components/ReservationContent/ConfirmInfo.js